import "./AdminUpload.scss";
import logo from "../../assets/logo/logo.png";
import { useState } from "react";
import { API_URL } from "../../utils/axios";
import axios from "axios";

//https://medium.com/@jon.glass82/using-the-cloudinary-upload-widget-with-react-js-c0854138cc29

const AdminUpload = (props) => {
  console.log(props);
  const [imageUrl, setImageUrl] = useState("");
  const [description, setDescription] = useState("");

  const handleChange = (e) => {
    setDescription(e.target.value);
  };
  const showWidget = () => {
    console.log("i fire");
    let widget = window.cloudinary.createUploadWidget(
      {
        cloudName: `df9ul5qs5`,
        uploadPreset: `snpdah9c`,
        max_files: 1,
      },
      (error, result) => {
        if (!error && result && result.event === "success") {
          setImageUrl(result.info.url);
        }
      }
    );
    widget.open();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;

    axios
      .post(API_URL + "/gallery", {
        gallery_image: e.target.upload.value,
        gallery_description: e.target.description.value,
      })
      .then((response) => (window.location = "/gallery"))
      .catch((error) => console.log(error));
  };

  return (
    <div className="admin-upload">
      <h1 className="admin-upload__title">UPLOAD A NEW PHOTO</h1>

      <img
        src={imageUrl !== "" ? imageUrl : logo}
        alt={"upload"}
        className="admin-upload__image"
      />
      <div className="admin-upload__upload" onClick={showWidget}>
        Click Here to upload your photo
      </div>
      <form className="admin-upload__form" onSubmit={handleSubmit}>
        <input
          className="admin-upload__input"
          type="hidden"
          id="upload"
          name="upload"
          placeholder="Upload"
          value={imageUrl}
        />
        <label htmlFor="description" className="admin-upload__label">
          DESCRIPTION
        </label>
        <textarea
          className="admin-upload__input"
          type="text"
          id="description"
          name="description"
          placeholder="Description"
          value={description}
          onChange={handleChange}
        />
        <button className="admin-upload__button">SUBMIT</button>
      </form>
    </div>
  );
};

export default AdminUpload;
